var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"authFrame",staticStyle:{"display":"none"},attrs:{"id":"authFrame","src":(_vm.url + "/app/authorize.html")}})}]

export { render, staticRenderFns }